import {
  ButtonGroup,
  ButtonGroupCloseColorEnum,
  ButtonGroupCornerEnum,
  ButtonSizeEnum,
  FontColorEnum,
  FontSizeEnum,
  FontWeightEnum,
  Typography,
} from '@acceso/design-system';
import clsx from 'clsx';

import { PRIORITY } from '@/features/broadcast-schedule/constants';
import { useParrillaFilters } from '@/stores/parrilla-filters';

export function BroadcastScheludeHeaderNumberFilter() {
  const { priorities, setFilters } = useParrillaFilters();

  const handlePriorityChange = (priority: number) => {
    if (priorities.includes(priority)) {
      setFilters({ priorities: priorities.filter(p => p !== priority) });
    } else {
      setFilters({ priorities: [...priorities, priority] });
    }
  };

  return (
    <div className="flex items-center gap-2">
      {PRIORITY.map(number => (
        <ButtonGroup
          key={number.value}
          size={ButtonSizeEnum.SM}
          onClick={() => handlePriorityChange(number.value)}
          onClickClose={() => handlePriorityChange(number.value)}
          closeColor={ButtonGroupCloseColorEnum.PRIMARY}
          isFilled={priorities.includes(number.value)}
          corner={ButtonGroupCornerEnum.FULL}
          className={clsx(
            'hover:!bg-neutral-20',
            priorities.includes(number.value)
              ? '!border-[2px] !border-accent-active-primary-20 bg-extra-new-95'
              : '!border'
          )}
          closeIcon={priorities.includes(number.value)}
        >
          <Typography
            fontSize={FontSizeEnum.Basic}
            weight={FontWeightEnum.Semibold}
            color={FontColorEnum.Dark10}
          >
            {number.render}
          </Typography>
        </ButtonGroup>
      ))}
    </div>
  );
}
